import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import AdminLayout from '@/components/admin/AdminLayout';
import SupervisorDashboard from '@/components/admin/SupervisorDashboard';
import { Users, Settings } from 'lucide-react';
import RoleSwitcher from '@/components/admin/RoleSwitcher';
import WelcomeBanner from '@/components/dashboard/WelcomeBanner';
import ChartThemeToggle from '@/components/dashboard/ChartThemeToggle';

export default function SupervisorDashboardPage() {
  const { user } = useAdminAuth();
  const navigate = useNavigate();

  return (
    <AdminLayout>
      <div className="space-y-8">
        {/* Welcome Banner */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
          <div className="flex-1">
            <WelcomeBanner
              role="supervisor"
              userName={user?.email?.split('@')[0] || 'Supervisor'}
              userEmail={user?.email}
              agencyName={user?.agency?.name}
              quickActions={[
                { label: 'View Patients', icon: Users, onClick: () => navigate('/admin/patients') },
                { label: 'Settings', icon: Settings, onClick: () => navigate('/admin/settings'), variant: 'outline' },
              ]}
            />
          </div>
          <div className="flex items-center gap-2">
            <ChartThemeToggle />
            <RoleSwitcher currentView="supervisor" />
          </div>
        </div>

        {/* Supervisor Dashboard Content */}
        <SupervisorDashboard />
      </div>
    </AdminLayout>
  );
}
